import { render, staticRenderFns } from "./heroSection.vue?vue&type=template&id=0e6a933f&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "heroSection.vue"
export default component.exports